<template>
  <div class="edit-platform">
    <div class="breadcrumb" style="background: #fff" v-if="basicInfo.tradeStatus === 'APPLY_REFUND' || basicInfo.tradeStatus === 'APPLY'">财务审核</div>
    <div class="breadcrumb" style="background: #fff" v-if="basicInfo.tradeStatus === 'AUDITED'">出纳打款</div>
    <div class="breadcrumb" style="background: #fff" v-if="basicInfo.tradeStatus === 'REJECTED' || basicInfo.tradeStatus === 'REFUNDED'">退款详情</div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" ref="rules" label-width="140px" class="demo-ruleForm">
        <el-form-item label="打款日期:" v-if="basicInfo.tradeStatus === 'REFUNDED'"> {{ basicInfo.dateCreated }} </el-form-item>
        <el-form-item label="申请日期:" v-if="basicInfo.tradeStatus === 'APPLY' || basicInfo.tradeStatus === 'AUDITED'"> {{ basicInfo.dateCreated }} </el-form-item>
        <el-form-item label="拒绝日期:" v-if="basicInfo.tradeStatus === 'REJECTED'"> {{ basicInfo.dateCreated }} </el-form-item>
        <el-form-item label="平台号:">
          <span>{{ basicInfo.store.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.store.name }} </el-form-item>
        <el-form-item label="退款类型:"> {{ $config.refundType[basicInfo.tradeMethod] }} </el-form-item>
        <el-form-item label="退款金额:"> {{ basicInfo.amount }} </el-form-item>
        <el-form-item label="清空礼金券:"> {{ basicInfo.bonus }} </el-form-item>
        <el-form-item label="备注:"> {{ basicInfo.remark }} </el-form-item>
        <!-- <el-form-item label="申请日期:">
          {{ basicInfo.dateCreated }}
        </el-form-item> -->
        <!-- <el-form-item label="打款日期:">
          {{ basicInfo.dateCreated }}
        </el-form-item> -->
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round v-if="basicInfo.tradeStatus === 'REJECTED' || basicInfo.tradeStatus === 'REFUNDED' || basicInfo.tradeStatus === 'AUDITED'" style="width: 100px" @click="back">返回
      </el-button>
      <el-button round style="width: 100px" v-if="basicInfo.tradeStatus === 'APPLY_REFUND' || basicInfo.tradeStatus === 'APPLY'" @click="checkType = 1, checkDialog = true">审核拒绝</el-button>
      <el-button type="primary" v-if="basicInfo.tradeStatus === 'APPLY_REFUND' || basicInfo.tradeStatus === 'APPLY'" round style="width: 100px;margin-left: 20px;"
        @click="checkType = 2, checkDialog = true"> 审核通过</el-button>
      <el-button type="primary" round v-if="basicInfo.tradeStatus === 'AUDITED'" style="width: 100px" @click="checkType = 3, checkDialog = true">确认打款 </el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <span>{{ checkType === 2 ? '是否确认审核通过？' : checkType === 1 ? '是否确认审核拒绝？' : "是否确认打款？" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { handleRefund } from '@/api/refund'

export default {
  name: 'audit',
  data () {
    return {
      loading: false,
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      handleType: '',
      basicInfo: {
        refer: {
          store: {
            salesman: {

            }
          }
        }
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$route.query.rowDate) {
      this.basicInfo = JSON.parse(this.$route.query.rowDate)
      console.log(this.basicInfo)
      // this.handleType = this.$route.query.handleType
    }
  },
  methods: {
    check () {
      let auditVo = {
        action: this.checkType === 2 ? 'audit' : this.checkType === 1 ? 'reject' : 'cashout',
        refundId: this.basicInfo.refundId
      }
      console.log(auditVo)
      console.log(this.checkType)
      this.loading = true
      handleRefund(auditVo).then(res => {
        if (res.data.success) {
          if (this.checkType === 3) {
            this.$message.success('打款成功')
          } else if (this.checkType === 2) {
            this.$message.success('审核成功')
          }
          // if (this.checkType) {
          //   this.storeMsg = res.data.data
          //   this.checkTrueDialog = true
          // } else {
          this.checkDialog = false
          this.$router.go(-1)
          this.loading = false
          // }
        } else {
          this.checkDialog = false
          this.loading = false
        }
      })
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";
</style>
